// extracted by mini-css-extract-plugin
export var cartContainer = "_p8-4";
export var gray = "_p8-1";
export var itemContainer = "_p8-2";
export var itemDetails = "_p8-3";
export var strong = "_p8-0";